<template>
  <div class="auth-buttons-wrapper">
    <a v-for="link of links" :key="link.name" class="auth-buttons-item paragraph-s" @click="link.click">{{ link.name }}</a>
  </div>
</template>

<script>
export default {
  props: {
    links: Array
  }
};
</script>

<style lang="scss" scoped>
.auth-buttons-wrapper {
  display: flex;
  & .auth-buttons-item {
    margin-right: 20px;
    border-bottom: 1px solid var(--dark-gray);
    color: var(--dark-gray);
    cursor: pointer;
    &:hover {
      border-color: var(--primary);
      color: var(--primary);
    }
  }
}
</style>
